const enums = {
  initialized: 'initialized',
  pending: 'pending',
  mined: 'mined',
  error: 'error',
  finalized: 'finalized'
};
export default enums;
